import { withModalConditionalRender } from '@billy/design-system'
import { ReactElement, useEffect } from 'react'

import { ModalId } from '../../../../../../enums/modalId'
import { useSegment } from '../../../../../../hooks'
import { SyncErrorTopBarContextProvider } from './contexts/syncErrorTopBarContext'
import { SkipAndCompleteSyncModal as SkipAndCompleteSyncModalComponent } from './elements/SkipAndCompleteSyncModal'
import { SyncErrorTopBarContent } from './elements/SyncErrorTopBarContent'
import { UnrecognizedVatRatesModal as UnrecognizedVatRatesModalComponent } from './elements/UnrecognizedVatRatesModal'

const UnrecognizedVatRatesModal = withModalConditionalRender(UnrecognizedVatRatesModalComponent)
const SkipAndCompleteSyncModal = withModalConditionalRender(SkipAndCompleteSyncModalComponent)

export const SyncErrorTopBar = (): ReactElement => {
  const { track } = useSegment()

  useEffect(() => {
    track('xxx-sales-HistoricalSync-Top Bar updated', {
      topBarType: 'error',
    })
  }, [track])

  return (
    <SyncErrorTopBarContextProvider>
      <SyncErrorTopBarContent />
      <UnrecognizedVatRatesModal id={ModalId.UnrecognizedVatRatesModal} />
      <SkipAndCompleteSyncModal id={ModalId.SkipAndCompleteSyncModal} />
    </SyncErrorTopBarContextProvider>
  )
}
